export default __webpack_public_path__ + "static/media/7f1b24c7360806452c7ada17543fe11b.svg";